export const ONBOARDING_STEPS = [
  {
    id: 1,
    key: 'organisation',
    title: 'Organisation Details',
    required: true,
    whatHappensHere:
      'Capture organisation details including business type and sub-type, branding, subdomain, license plan, and session settings for your workspace.',
  },
  {
    id: 2,
    key: 'account',
    title: 'Account Creation',
    required: true,
    whatHappensHere:
      'Create your first account for the organisation with account name, contacts, and other relevant details.',
  },
  {
    id: 3,
    key: 'organisation_mapping',
    title: 'Organisation Mapping',
    required: true,
    whatHappensHere:
      'After the organisation is created, link it with existing organisations (source and target), same as Management → Organisations Mapping.',
  },
  {
    id: 4,
    key: 'profile_users',
    title: 'Profile, Permissions & Users',
    required: true,
    whatHappensHere:
      'Set access permissions for your organisation profile and invite team members with the right roles in one place.',
  },
  {
    id: 5,
    key: 'whatsapp',
    title: 'WhatsApp Setup',
    required: false,
    skipLabel: 'Skip for now',
    skipConfirmTitle: 'Skip WhatsApp setup?',
    skipConfirmText:
      'You can configure WhatsApp later. Continue to campaign setup now. Messaging features need WhatsApp before they can go live.',
    whatHappensHere:
      'Connect and verify your WhatsApp Business API for customer messaging and campaigns.',
  },
  {
    id: 6,
    key: 'campaign',
    title: 'Campaign Goals',
    required: true,
    whatHappensHere:
      'Select one or more campaign objectives. Sample campaign names are suggested from your business type; customize each.',
  },
  {
    id: 7,
    key: 'form',
    title: 'Form Builder',
    required: true,
    whatHappensHere:
      'Build lead capture forms with the fields you need and preview how respondents will see them. Complete setup when finished.',
  },
];

export const getStepById = (id) => ONBOARDING_STEPS.find((s) => s.id === id);
export const getStepByKey = (key) => ONBOARDING_STEPS.find((s) => s.key === key);
export const TOTAL_STEPS = ONBOARDING_STEPS.length;
export const LAST_STEP_ID = TOTAL_STEPS;
